import { GoogleSheetsIcon } from '../../../assets/icons/google-sheets';
import { createEmbedProvider } from '../factory';

/**
 * Google Sheets URL regex pattern
 * Matches: docs.google.com/spreadsheets/d/SPREADSHEET_ID/...
 * Captures the spreadsheet ID in group 1.
 */
export const GOOGLE_SHEETS_REGEX = /^https?:\/\/docs\.google\.com\/spreadsheets\/d\/([^/?#]+)/i;

export const googleSheetsProvider = createEmbedProvider({
  id: 'google-sheets',
  label: 'Google Sheets',
  icon: <GoogleSheetsIcon className="size-5" />,
  regex: GOOGLE_SHEETS_REGEX,
  buildEmbedUrl: (match) => `https://docs.google.com/spreadsheets/d/${match[1]}/preview`,
});
